export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL;
export const SWAGGER_URL = process.env.REACT_APP_BASE_URL;

export const getImageUrl = (filePath) => {
  return `${IMAGES_URL}/${filePath}`;
};